/* ================================================== */
/* SEARCH > Close search
/* ================================================== */

function closeSearch() {

	// Hide modal
	$searchContainer.removeClass('search--open');
	setTimeout(function(){
		$searchContainer.css('display', 'none');
	}, 500);

	// Reset modal attributes
	$searchContainer.removeAttr('open').attr({
		'tabindex'    : '-1',
		'aria-hidden' : 'true'
	});

	// Reset focus
	$inputSearch.blur();

	// Set unfocusable elements focusable
	$('body').removeClass('overflow-hidden');
	var $hiddenElements = $('body > .disable.disable--focus.no-delay');
	$hiddenElements.removeClass('disable disable--focus no-delay');
	var attr = $hiddenElements.attr('aria-hidden');
	if (typeof attr !== typeof undefined && attr !== false && $hiddenElements.attr('aria-hidden') == 'true') {
		$hiddenElements.removeAttr('aria-hidden');
	}

	// Set focus back to element that triggered modal
	if (typeof lastFocusedElement !== 'undefined' && lastFocusedElement !== false && lastFocusedElement !== null) {
		lastFocusedElement.focus();
	}

}